import { useEffect, useState } from 'react';

import { Form } from 'antd';
import { AssessmentAPIUseCaseInterface } from 'application/usecases/AssessmentUseCase';
import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import { PropertyUseCaseInterface } from 'application/usecases/PropertyUseCase';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch, useAppSelector } from 'presentation/redux/hooks';
import { useParams } from 'react-router-dom';
import { ImageRow } from './components/ImageRow';
import { MarketPrice } from './components/MarketPrice';
import { PropertyDescription } from './components/PropertyDescription';
import { ListedPropertyRoomGetAssessmentDetail } from './models/Property';

interface props {
    propertyUseCase: PropertyUseCaseInterface;
    masterUseCase: MasterUseCaseInterface;
    assessmentUseCase: AssessmentAPIUseCaseInterface;
}
const CU03602Page = ({ assessmentUseCase }: props) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const { propertyId, registeredId } = useParams();
    const [detailAssessment, setDetailAssessment] =
        useState<ListedPropertyRoomGetAssessmentDetail>();
    const storedInput = useAppSelector((state) => state.CU03101Slice.storedInput);

    useEffect(() => {
        if (storedInput) form.setFieldsValue(storedInput);
        getListedPropertyRoomGetAssessmentDetail({
            listedPropertyId: Number(registeredId),
        });
    }, []);

    const getListedPropertyRoomGetAssessmentDetail = async (params: {
        listedPropertyId: number;
    }) => {
        try {
            dispatch(startFetching());
            const responses = await assessmentUseCase.getAssessmentDetail(params);
            setDetailAssessment(responses.result);
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
                paddingLeft: 20,
            }}
            className="CU-033-01-container CU-036-02-container "
        >
            <PageTitle title="物件詳細" />
            <section
                style={{
                    height: '100%',
                    width: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <div className="main-container">
                    <div className="title">{detailAssessment?.propertyName}</div>
                    <MarketPrice detailAssessment={detailAssessment} />
                    <ImageRow
                        imageURLs={
                            detailAssessment?.propertyImages?.length
                                ? detailAssessment?.propertyImages
                                : ['']
                        }
                    />
                    <PropertyDescription detailAssessment={detailAssessment} />
                </div>
            </section>
        </div>
    );
};
export default CU03602Page;
